(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["backup-navigation-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      };
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      };
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials_ugc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ugc-collage')) {
    class UgcCollage extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('.ugc-collage__grid');
        if (!this.grid || !('ResizeObserver' in window)) return;

        this.frame = null;
        this.layout = this.layout.bind(this);
        this.classList.add('is-masonry');

        this.observer = new ResizeObserver(() => this.schedule());
        this.observer.observe(this.grid);
        Array.from(this.grid.children).forEach((card) => this.observer.observe(card));

        this.layout();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      schedule() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(this.layout);
      }

      layout() {
        this.frame = null;
        const style = getComputedStyle(this.grid);
        const row = parseFloat(style.gridAutoRows) || 4;
        const gap = parseFloat(style.rowGap) || 0;
        const cards = Array.from(this.grid.children);

        // Read all heights first, then write, to avoid layout thrashing
        const heights = cards.map((card) => card.firstElementChild.getBoundingClientRect().height);
        cards.forEach((card, i) => {
          const span = Math.max(1, Math.ceil((heights[i] + gap) / (row + gap)));
          card.style.gridRowEnd = 'span ' + span;
        });
      }
    }
    customElements.define('ugc-collage', UgcCollage);
  }

  } catch(e) { console.error(e); }
})();
})();
